import { create } from 'zustand';

type CanvasInsertionToastState = {
  message: string | null;
  setMessage: (message: string | null) => void;
};

export const useCanvasInsertionToastStore = create<CanvasInsertionToastState>()((set) => ({
  message: null,
  setMessage: (message) => set({ message }),
}));
